﻿// @ts-nocheck
// session list + timer + manual entry

// ========== Sessions Management ==========
async function loadSessions() {
  try {
    const res = await fetchWithAuth("/api/sessions");
    if (!res.ok) throw new Error("Failed to load sessions");
    const payload = await res.json();
    sessions = Array.isArray(payload) ? payload : (payload.sessions || []);
    renderSessionsTable();
    updateStats();
  } catch (err) {
    console.error(err);
  }
}

function renderSessionsTable() {
  const logTableBody = document.querySelector("#logTable tbody");
  if (!logTableBody) return;

  // Create a date object for today at midnight (local time)
  const todayMidnight = new Date();
  todayMidnight.setHours(0, 0, 0, 0);
  
  // Create a date object for tomorrow at midnight (local time)
  const tomorrowMidnight = new Date();
  tomorrowMidnight.setDate(tomorrowMidnight.getDate() + 1);
  tomorrowMidnight.setHours(0, 0, 0, 0);
  
  // Filter sessions that fall between today's midnight and tomorrow's midnight
  const todaysSessions = sessions.filter((s) => {
    const sessionTime = s.startTime;
    return sessionTime >= todayMidnight.getTime() && sessionTime < tomorrowMidnight.getTime();
  });

  if (todaysSessions.length === 0) {
    logTableBody.innerHTML = "<tr><td colspan='5' style='text-align: center; color: var(--text-secondary);'>No sessions logged today</td></tr>";
    return;
  }

  logTableBody.innerHTML = todaysSessions.map((s) => {
    const start = new Date(s.startTime).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    const rate = s.rate || 180;
    const editPayload = `{id: '${s.id}', projectId: '${s.projectId}', projectName: '${s.projectName}', startTime: ${s.startTime}, hours: ${s.hours}, rate: ${s.rate}, notes: '${(s.notes || '').replace(/'/g, "\\'")}', earned: ${s.earned}}`;
    return `
      <tr>
        <td><strong>${s.projectName}</strong></td>
        <td>${start}</td>
        <td>${s.hours.toFixed(2)}h</td>
        <td>$${s.earned.toFixed(2)} <span class="rate-hint">@$${rate}/hr</span></td>
        <td class="row-actions">
          <button class="btn btn-secondary btn-sm" onclick="openEditModal(${editPayload})" title="Edit">✎</button>
          <button class="btn btn-danger btn-sm" onclick="deleteSession('${s.id}')" title="Delete">×</button>
        </td>
      </tr>
    `;
  }).join('');
}

function updateStats() {
  // Create a date object for today at midnight (local time)
  const todayMidnight = new Date();
  todayMidnight.setHours(0, 0, 0, 0);
  
  // Create a date object for tomorrow at midnight (local time)
  const tomorrowMidnight = new Date();
  tomorrowMidnight.setDate(tomorrowMidnight.getDate() + 1);
  tomorrowMidnight.setHours(0, 0, 0, 0);
  
  // Filter sessions that fall between today's midnight and tomorrow's midnight
  const todaysSessions = sessions.filter((s) => {
    const sessionTime = s.startTime;
    return sessionTime >= todayMidnight.getTime() && sessionTime < tomorrowMidnight.getTime();
  });
  
  const totalEarned = todaysSessions.reduce((sum, s) => sum + (s.earned || 0), 0);

  const totalEarnedEl = document.getElementById("totalEarned");
  if (totalEarnedEl) {
    totalEarnedEl.textContent = `$${totalEarned.toFixed(2)} today`;
  }
}

async function startTimer() {
  const projectId = document.getElementById("projectSelect").value;
  if (!projectId) {
    alert("Please select a project.");
    return;
  }

  const project = projects.find((p) => p.id === projectId);
  if (!project) return;

  try {
    const startBtn = document.getElementById("startBtn");
    const stopBtn = document.getElementById("stopBtn");
    startBtn.disabled = true;

    const res = await fetchWithAuth("/api/start", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        projectId,
        projectName: project.name,
        rate: project.defaultRate,
      }),
    });

    if (!res.ok) throw new Error("Failed to start timer");
    currentSession = await res.json();

    startBtn.style.display = "none";
    stopBtn.style.display = "inline-block";

    const statusEl = document.getElementById("currentStatus");
    statusEl.textContent = `Running: ${currentSession.projectName} @ $${currentSession.rate}/hr`;

    if (timerInterval) clearInterval(timerInterval);
    updateTimer();
    timerInterval = setInterval(updateTimer, 500);

    await loadSessions();
    startBtn.disabled = false;
  } catch (err) {
    console.error(err);
    alert("Error starting timer.");
    const startBtn = document.getElementById("startBtn");
    startBtn.disabled = false;
  }
}

async function stopTimer() {
  try {
    const stopBtn = document.getElementById("stopBtn");
    const startBtn = document.getElementById("startBtn");
    stopBtn.disabled = true;

    const res = await fetchWithAuth("/api/stop", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    });

    if (!res.ok) throw new Error("Failed to stop timer");

    currentSession = null;
    startBtn.style.display = "inline-block";
    stopBtn.style.display = "none";

    const statusEl = document.getElementById("currentStatus");
    statusEl.textContent = "No active session";

    stopLocalTimer();
    await loadSessions();
    stopBtn.disabled = false;
  } catch (err) {
    console.error(err);
    alert("Error stopping timer.");
    const stopBtn = document.getElementById("stopBtn");
    stopBtn.disabled = false;
  }
}

// ========== Manual Session Logging ==========
async function addManualSession() {
  const date = document.getElementById("manualDate").value;
  const time = document.getElementById("manualTime").value || "00:00"; // Default to midnight if not specified
  const hours = parseFloat(document.getElementById("manualHours").value);
  const projectId = document.getElementById("manualProjectSelect").value;
  const notes = document.getElementById("manualNotes").value.trim();

  if (!date || !hours || !projectId) {
    alert("Please fill in date, time (optional), hours, and project.");
    return;
  }

  if (hours <= 0) {
    alert("Hours must be greater than 0.");
    return;
  }

  const project = projects.find((p) => p.id === projectId);
  if (!project) {
    alert("Project not found.");
    return;
  }

  try {
    const addBtn = document.getElementById("addManualSessionBtn");
    addBtn.disabled = true;

    // Convert date + time to local timestamp
    const [year, month, day] = date.split("-").map(Number);
    const [timeHour, timeMin] = time.split(":").map(Number);
    const dateObj = new Date(year, month - 1, day, timeHour, timeMin, 0, 0);
    const startTime = dateObj.getTime();
    const endTime = startTime + hours * 60 * 60 * 1000;

    const res = await fetchWithAuth("/api/sessions/manual", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        projectId,
        projectName: project.name,
        startTime,
        endTime,
        hours,
        rate: project.defaultRate,
        notes,
      }),
    });

    if (!res.ok) {
      const error = await res.text();
      alert(`Error: ${error}`);
      addBtn.disabled = false;
      return;
    }

    alert("Session logged successfully!");
    document.getElementById("manualDate").value = "";
    document.getElementById("manualTime").value = "";
    document.getElementById("manualHours").value = "";
    document.getElementById("manualProjectSelect").value = "";
    document.getElementById("manualNotes").value = "";
    await loadSessions();
    addBtn.disabled = false;
  } catch (err) {
    console.error("Error logging session:", err);
    alert("Error logging session.");
    const addBtn = document.getElementById("addManualSessionBtn");
    addBtn.disabled = false;
  }
}
